import { FC } from 'react';
import { ReactComponent as Background } from './backgrounds/background.svg';
import { ReactComponent as Logo } from './logos/CogniGuardNewLogoo.svg';
import { ReactComponent as ClosedEye } from './inputIcons/Hide.svg';
import { ReactComponent as OpenEye } from './inputIcons/eye.svg';
import { ReactComponent as Mail } from './inputIcons/Message.svg';
import { ReactComponent as Search } from './inputIcons/Search.svg';
import { ReactComponent as FiltersIcon } from "./table/FiltersIcon.svg"
import { ReactComponent as SortArrows } from './table/sortArrows.svg';
import { ReactComponent as Eye } from './table/eye.svg';
import { ReactComponent as BackIcon } from './inputIcons/BackIcon.svg';
import { ReactComponent as RadioButtonOn } from './inputIcons/RadioButtonOn.svg';
import { ReactComponent as RadioButtonOff } from './inputIcons/RadioButtonOff.svg';


import { ReactComponent as Dashboard } from './menu/dashboard.svg';
import { ReactComponent as User } from './menu/user.svg';
import { ReactComponent as UserAdd } from './menu/user-add.svg';
import { ReactComponent as Devices } from './menu/devices.svg';
import { ReactComponent as Sites } from './menu/sites.svg';
import { ReactComponent as Fota } from './menu/fota.svg';
import { ReactComponent as Notification } from './menu/Notification.svg';
import { ReactComponent as Logout } from './menu/logout.svg';
import { ReactComponent as More } from './menu/More.svg';
import { ReactComponent as ActiveUsers } from "./homeScreens/cardsIcons/activeUsers.svg"
import { ReactComponent as Centers } from "./homeScreens/cardsIcons/centers.svg"
import { ReactComponent as Patients } from "./homeScreens/cardsIcons/patients.svg"
import { ReactComponent as Plus } from "./table/plus.svg"
import { ReactComponent as PatientsVerified } from "./homeScreens/cardsIcons/patients-verified.svg"
import { ReactComponent as Graph } from "./homeScreens/cardsIcons/graph.svg"
import { ReactComponent as UserAddIcon } from "./homeScreens/cardsIcons/userAddIcon.svg"
import { ReactComponent as DevicesIcon } from "./homeScreens/cardsIcons/devicesIcon.svg"
import { ReactComponent as ErrorIcon } from "./homeScreens/cardsIcons/errorIcon.svg"
import { ReactComponent as CalenderTime } from "./table/CalenderTime.svg"
import { ReactComponent as Activity } from "./table/activity.svg"
import { ReactComponent as ReportTable } from "./table/reportTable.svg"
import { ReactComponent as Male } from "./table/male.svg"
import { ReactComponent as Female } from "./table/female.svg"
import { ReactComponent as pincel } from "./table/pincel.svg"
import { ReactComponent as PreferencesOpenIcon } from "../assats/notification/preferencesOpen.svg";
import { ReactComponent as PreferencesClosedIcon } from "../assats/notification/preferencesClosed.svg";
import { ReactComponent as deleteIcone } from "./table/delete.svg";
import { ReactComponent as publish } from "./table/publish.svg";
import { ReactComponent as backup } from "./inputIcons/backup.svg";
import { ReactComponent as pause } from "./fota/pause.svg";
import { ReactComponent as cancel } from "./fota/cancel.svg";
import { ReactComponent as folder } from "./fota/folder.svg";
import { ReactComponent as checked } from "./fota/checked.svg";
import { ReactComponent as attention } from "./table/attention.svg";
import { ReactComponent as exportXlsx } from "./table/export.svg";




const svgs = {
    logos: {
        Background,
        Logo,
        ClosedEye,
        OpenEye,
        Mail,
        Search,
        FiltersIcon,
        Plus,
        SortArrows,

    },
    icons: {
        BackIcon,
        RadioButtonOn,
        RadioButtonOff,
        Eye,
        CalenderTime,
        Activity,
        ReportTable,
        Male,
        Female,
        pincel,
        PreferencesOpenIcon,
        PreferencesClosedIcon,
        deleteIcone,
        attention,
        exportXlsx

    },
    menu: {
        Dashboard,
        User,
        UserAdd,
        Devices,
        Sites,
        Fota,
        Notification,
        Logout,
        More,
    },
    cards: {
        ActiveUsers,
        Centers,
        Patients,
        PatientsVerified,
        Graph,
        UserAddIcon,
        DevicesIcon,
        ErrorIcon
    },

    fota: {
        pause,
        cancel,
        folder,
        backup,
        publish,
        checked,
    }

    // Add other SVGs here
};


const logos = {

    coraLogo: require("./logos/coraLogo.png"),
}

const homeScreenImages = {
    coraLogo: require("./homeScreens/logo.png"),

}


// const background = 

export {
    logos,
    homeScreenImages,
    svgs
}